import Box from "@mui/material/Box";
import { animationSuccessStyles } from "./animationSuccessStyles";
import { useTheme } from "@mui/material/styles";
import { Player } from "@lottiefiles/react-lottie-player";
import { ASSETS_PATH } from "../../services/endpoints";

export const AnimationSuccess = () => {
  const theme = useTheme();
  const classes = animationSuccessStyles(theme);
  const animationData = `${ASSETS_PATH}/img/success_animation.json`;

  return (
    <Box sx={classes.animationBox}>
      <Player
        autoplay
        loop
        speed={0.8}
        src={animationData}
        style={classes.player}
      ></Player>
    </Box>
  );
};
